import { render, staticRenderFns } from "./LearnList.vue?vue&type=template&id=6a8f39e8&"
import script from "./LearnList.vue?vue&type=script&lang=js&"
export * from "./LearnList.vue?vue&type=script&lang=js&"
import style0 from "./LearnList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports